module.exports = __webpack_public_path__ + "static/img/bg33.39f0b129.png";